// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderLoading_container__119TY","col1":"HeaderLoading_col1__1qvli","logo":"HeaderLoading_logo__1U2m_","linksInt":"HeaderLoading_linksInt__3sX1h"};